export default "__VITE_ASSET__7441ea2e__"